import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isRegExp.js
// module id = 161
// module chunks = 3